import { AsyncPipe, LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LocalizationScopeDirective, LocalizePipe } from '@capital-access/common/localization';
import { FireflyDrawerContent } from '@capital-access/firefly/components';
import { NotificationsDrawerActions } from '../../+store/notifications-drawer.actions';
import {
  selectCategories,
  selectError,
  selectLoading,
  selectTypePageState
} from '../../+store/notifications-drawer.selectors';
import { NotificationTypePageState } from '../../+store/notifications-drawer.state';
import { NOTIFICATIONS_LOCALIZATION_SCOPE } from '../../constants/notifications-drawer.constants';
import { NotificationCategoryDto } from '../../models/notifications-grouped.model';
import { NotificationTypeListComponent } from '../notification-type-list/notification-type-list.component';

@Component({
  selector: 'ca-notifications-drawer',
  templateUrl: './notifications-drawer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AsyncPipe,
    LowerCasePipe,
    NgbNavModule,
    LocalizationScopeDirective,
    LocalizePipe,
    NotificationTypeListComponent
  ]
})
export class NotificationsDrawerComponent extends FireflyDrawerContent<Record<string, never>> implements OnInit {
  private store = inject(Store);
  private router = inject(Router);

  categories$: Observable<NotificationCategoryDto[]> = this.store.select(selectCategories);
  loading$: Observable<boolean> = this.store.select(selectLoading);
  error$: Observable<string | null> = this.store.select(selectError);

  activeTabId: string | null = null;
  readonly localizationScope = NOTIFICATIONS_LOCALIZATION_SCOPE;

  ngOnInit(): void {
    this.store.dispatch(NotificationsDrawerActions.loadNotifications());
  }

  getTypePageState(typeCode: string): Observable<NotificationTypePageState | undefined> {
    return this.store.select(selectTypePageState(typeCode));
  }

  onLoadMore(typeCode: string): void {
    this.store.dispatch(NotificationsDrawerActions.loadMoreForType({ typeCode }));
  }

  onMarkAsRead(event: { notificationId: number; typeCode: string }): void {
    this.store.dispatch(NotificationsDrawerActions.markAsRead({ notificationId: event.notificationId }));
  }

  onDelete(event: { notificationId: number; typeCode: string }): void {
    this.store.dispatch(
      NotificationsDrawerActions.deleteNotification({
        notificationId: event.notificationId,
        typeCode: event.typeCode
      })
    );
  }

  onRetry(): void {
    this.store.dispatch(NotificationsDrawerActions.loadNotifications());
  }

  navigateToDataAlerts(): void {
    this.close();
    this.router.navigateByUrl('/data-alerts');
  }

  trackByCategory(_: number, cat: NotificationCategoryDto): string {
    return cat.category;
  }
}
